// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FRfgC","form":"X6OvT","submit":"kmUNp"};